<template>
    <div class="cabinet-select">
        <div class="cabinet-select__container" v-if="!editFavorite && !removeFavorite"
             :class="{'cabinet-select__container--not-main': group.base === 'N'}">
            <div  class="cabinet-select__btn" @click="active = !active" v-if="screenWidth > 992">
                <div v-if="group.items||true">
                <span ref="toggleInfo" v-if="!active">+</span>
                <span ref="toggleInfo" v-else>-</span>
                </div>
            </div>
            <div class="cabinet-select__info">
                <div class="cabinet-select__info-title">
                    {{ group.name }}
                </div>
                <div class="cabinet-select__info-quantity">
                    {{ group.count }} {{ message.textCount }}
                </div>
            </div>
            <div ref="imgList" class="cabinet-select__img-list">
                <div v-if="group.items" class="cabinet-select__items">
                    <img
                        v-for="image in group.items.slice(0, 5)"
                        :key="image.offer && image.offer.id || image.id"
                        :src="image.picture.src"
                        :alt="image.picture.alt"
                    >

                    <div class="label-counter" v-if="group.count > 5">+{{ group.count - 5 }}</div>
                </div>
                <span v-if="screenWidth < 992" @click="active = !active">{{ message.textDetail }}</span>
            </div>

            <div class="cabinet-select__settings-btn">
                <div class="cabinet-select__main-label" v-if="group.base === 'Y'">
                    {{ message.textMain }}
                </div>
                <div class="cabinet-select__edit">
                    <span @click="editFavorite = true">{{ message.textEdit }}</span>
                </div>
                <div class="cabinet-select__delete-btn" @click="removeFavorite = true">
                    <img src="/local/templates/love-you/images/front-end/close.svg" alt="delete">
                </div>
            </div>
        </div>

        <edit-favorite-item v-if="editFavorite" :group="group" :value="group.name" @showEditSettings="showEditSettings" :groupId="group.id"/>
        <delete-favorite-item v-if="removeFavorite" @showRemoveBlock="showRemoveBlock" :groupId="group.id"/>

        <SlideUpDown :modelValue="active" v-if="group.items">
            <div class="cabinet-select__slide-container">
                <div class="cabinet-select__chose-all">
                    <label @change="chooseAll">
                        <input type="checkbox" ref="chooseAll">
                        <span class="label-input"></span>
                       <span>{{ message.textTakeAll }}</span>
                    </label>
                    <div class="cabinet-select__change" v-if="checked || selectAll">
                        <span @click="openMoveModal(idList, group.id)">{{ message.textMove }}</span>
                        <span @click="deleteGoodFromFavorite(idList, group.id)">{{ message.btnDel }}</span>
                    </div>
                </div>
                <div class="cabinet-select__goods-list">
                    <div class="cabinet-select__goods"
                         v-for="( good, i ) in group.items"
                         :key="good.offer && good.offer.id || good.id"
                    >
                        <div class="cabinet-select__goods-top">
                            <label>
                                <input ref="chooseElem" class="cabinet-select__checkbox" type="checkbox"
                                   @change="chooseItem(good.offer && good.offer.id || good.id)">
                                <span class="label-input"></span>
                            </label>
                            <div class="cabinet-select__remove-btn" @click="deleteGoodFromFavorite(good, group.id)">
                                <img src="/local/templates/love-you/images/front-end/close.svg" alt="delete">
                            </div>
                        </div>
                        <div class="cabinet-select__goods-content">
                            <div class="cabinet-select__goods-image">
                                <a :href="good.detailPage">
                                    <img :src="good.picture.src"
                                         :alt="good.picture.alt">
                                </a>
                            </div>
                            <div class="cabinet-select__goods-title">
                                <div class="cabinet-select__goods-sale" v-if="good.price.discountPercent">
                                    {{ good.price.discountPercent }}%
                                </div>
                                <a :href="good.detailPage">
                                    <span>{{ good.name }}</span>
                                </a>
                            </div>
                            <div class="cabinet-select__goods-price">
                                {{ good.price.printPrice }}
                                <span class="cabinet-select__price-sale"
                                      v-if="good.price.printPriceOld">{{ good.price.printPriceOld }}</span>
                            </div>
                        </div>
                        <div class="cabinet-select__goods-bottom">
                            <div class="cabinet-select__cart-btn">
                                <a :href="good.detailPage">{{ message.linkItem }}</a>
                            </div>
<!--                            <div class="cabinet-select__size-select" v-if="good.propsForCheck.SIZES">-->
<!--&lt;!&ndash;                                <def-select-wrapper :size="good.propsForCheck.SIZES">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <template v-slot:header>&ndash;&gt;-->
<!--&lt;!&ndash;                                        Выберите размер&ndash;&gt;-->
<!--&lt;!&ndash;                                    </template>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div v-for="item in good.propsForCheck.SIZES" @click="">{{ item.displayValue }}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </def-select-wrapper>&ndash;&gt;-->
<!--                                <select>-->
<!--                                    <option :value="size.value" v-for="size in good.propsForCheck.SIZES">-->
<!--                                        {{ size.displayValue }}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                            <div class="cabinet-select__cart-btn"-->
<!--                                 :class="{'cabinet-select__cart-btn&#45;&#45;width' : !good.propsForCheck.SIZES}"-->
<!--                                 @click="addToBasket(good.offer && good.offer.id || good.id)"-->
<!--                            >-->
<!--                                <img src="/local/templates/love-you/images/front-end/bag.svg" alt="bag">-->
<!--                                <span v-if="!good.propsForCheck.SIZES">{{ message.btnAdd }}</span>-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </SlideUpDown>
        <!--        <div class="cabinet-select__bottom-line"></div>-->
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: "cabinet-select-item",
    selector: "cabinet-select-item",
    props: {
        group: {
            type: Object,
        },

    },
    data() {
        return {
            checked: false,
            active: false,
            selectAll: false,
            idList: [],
            editFavorite: false,
            removeFavorite: false,
        }
    },
    methods: {
        ...mapActions({
            basketAdd: 'basket/add',
        }),
        showEditSettings(edit) {
            this.editFavorite = edit;
        },
        showRemoveBlock(remove) {
            this.removeFavorite = remove;
        },
        chooseAll() {
            this.selectAll = !this.selectAll;
            const checkboxes = this.$refs.chooseElem;
            if (this.selectAll) {
                checkboxes.forEach(el => el.checked = true);
                this.idList = [...this.group.items.map(el => {
                    return el.offer && el.offer.id || el.id;
                })]

            } else {
                checkboxes.forEach(el => el.checked = false);
                this.idList.splice(0, this.idList.length);
            }

            this.searchActiveCheckbox();

        },
        deleteGoodFromFavorite(item, groupId) {
            this.$DefModal.show({
                name: 'favourite-modal-delete',
                width: '440px',
                props: {
                    item,
                    groupId,
                }
            });
            // this.$modal.show({
            //         template: `
            //             <favourite-modal-delete :item="item" :groupId="groupId" @close="$emit('close')"/>`,
            //         props: {
            //             item: {
            //                 type: [Object, Array],
            //             },
            //             groupId: {
            //                 type: String,
            //             },
            //         },
            //     },
            //     {
            //         item,
            //         groupId,
            //     },
            //     {
            //         height: 'auto',
            //         width: '440px',
            //         adaptive: true,
            //     })
        },
        openMoveModal(item) {
            this.$DefModal.show({
                name: 'favourite-modal-move',
                width: '440px',
                props: {
                    item,
                }
            });
            // this.$modal.show({
            //         template: `
            //             <favourite-modal-move :item="item" @close="$emit('close')"/>`,
            //         props: {
            //             item: {
            //                 type: [Object, Array],
            //             },
            //         },
            //     },
            //     {
            //         item,
            //     },
            //     {
            //         height: 'auto',
            //         width: '440px',
            //         adaptive: true,
            //     })
        },
        // Выбрать товар
        chooseItem(id) {
            let index = this.idList.indexOf(id);
            if (index > -1) {
                this.idList.splice(index, 1);
            } else {
                this.idList.push(id);
            }

            this.searchActiveCheckbox();

            console.log('selectAll', this.selectAll);
            console.log('checked', this.checked);
        },
        searchActiveCheckbox() {
            if (this.idList.length > 0) {
                this.checked = true;
            } else {
                this.checked = false;
                this.selectAll = false;
                this.$refs.chooseAll.checked = false;
            }
        },
        addToBasket(id) {
            this.basketAdd(id);
        }
    },
    computed: {
        ...mapState({
            message: ({ favourite }) => favourite?.data?.message,
        }),
    },

    mounted() {

    },
}
</script>

<style scoped lang="scss">

.cabinet-select {
    border-bottom: 1px solid #DFDFDF;
    //@include point-lg{
    //    margin-top: -18px;
    //}
    .prompt-enter-active {
        transition: opacity .3s ease;
    }

    .prompt-leave-active {
        transition: opacity .5s linear;
    }

    .prompt-enter, .prompt-leave-to {
        opacity: 0;
    }

     &__container {
        background-color: #FFFFFF;
        display: grid;
        grid-template-columns: 1fr 1fr;
        padding: 16px 0;

        @include point-xl {
            min-width: 46.75rem;
            //max-height: 5rem;
            display: grid;
            grid-template-columns: 6% 16% 51% 26%;
            grid-template-rows: 5rem;
            align-items: center;
            padding: 0;
        }

        &--not-main {
            grid-template-columns: 1fr 1fr;


            @include point-xl {
                grid-template-columns: 6% 16% 61% 16%;
            }
        }
    }

    &__items {
        display: flex;
    }

    &__settings-btn {
        grid-area: 1 / 2 / 2 / 3;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        @include point-xl {
            grid-area: auto;
        }
    }

    &__btn {
        cursor: pointer;
        font-size: rem(24);
    }

    &__info {
        grid-area: 1 / 1 / 2 / 2;

        @include point-xl {
            grid-area: auto;
        }

        &-title {
            font-weight: 500;
            font-size: rem(16);
            line-height: 115%;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: #191918;
        }

        &-quantity {
            font-weight: normal;
            font-size: rem(14);
            line-height: 100%;
            color: #757575;
        }
    }

    &__main-label {
        font-weight: 500;
        font-size: rem(12);
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #618EAF;
        display: flex;
        align-items: center;
        text-align: center;

        &:before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 4px;
            margin-bottom: 5px;
            margin-right: 5px;
            border-radius: 50%;
            background-color: #618EAF;
        }
    }

    &__edit, &__change {
        font-weight: 500;
        font-size: rem(10);
        line-height: 115%;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #191918;
        text-align: center;
        cursor: pointer;
        @include point-md {
            font-size: rem(12);
        }

        span {
            border-bottom: rem(1) dashed #191918;

        }
    }

    &__edit {
        margin: 0 13px;

        @include point-md {
            margin: 0 21px;
        }
    }

    &__change {
        display: flex;

        span {
            margin: 0 5px;

            @include point-xl {
                margin: 0 15px;
            }
        }

        .prompt {
            color: red;
            cursor: default;
            border: none;
        }
    }


    &__img-list {
        display: flex;
        grid-area: 2 / 1 / 3 / 3;
        margin-top: 16px;
        align-items: center;
        justify-content: space-between;
        @include point-xl {
            grid-area: auto;
            margin-top: 0;
        }

        img {
            height: rem(36);
            width: rem(33);
            margin-right: 8px;
            @include point-md {
                margin-right: rem(24);
                width: rem(36);
            }
        }

        span {
            color: #757575;
            border-bottom: rem(1) dashed #757575;
            font-size: rem(10);
            text-transform: uppercase;
            letter-spacing: 0.1em;
            font-weight: 500;
            margin-left: 15px;
            @include point-md {
                font-size: rem(12);
            }

        }

        .label-counter {
            width: rem(36);
            height: rem(36);
            background-color: #B8D9EC;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #467496;
            padding-top: rem(1);
        }
    }

    &__delete-btn {
        cursor: pointer;
        justify-self: right;
    }

    &__bottom-line {
        height: rem(1);
        background-color: #DFDFDF;
        max-width: rem(940);
        margin: 0 auto;
    }

    &__slide-container {
        display: flex;
        flex-direction: column;
        background-color: #F7F8F9;
    }

    &__chose-all {
        background-color: white;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: rem(8) rem(8) rem(4) rem(8);
        padding: 6px 16px;
        @include point-md{
            margin: rem(16) rem(16) rem(4) rem(16);
        }

        //label {
        //
        //}

        input {
            margin: 0;
            @include point-md{
                margin-right: 6px;
            }
        }
    }

    &__goods-list {
        margin: 0 rem(8) rem(8) rem(8);
        display: flex;
        flex-wrap: wrap;

        :nth-child(3n+3) {
            margin-right: 0;
        }

        @include point-md{
            margin: 0 rem(16) rem(16) rem(16);
        }

        @include point-xl {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    &__goods {
        height: rem(470);
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: #FFFFFF;
        margin-bottom: rem(4);
        padding: 16px;
        @include point-md {
            width: 49%;
            &:nth-child(odd) {
                margin-right: rem(4);
            }
        }

        @include point-xl {
            width: rem(300);
            margin-right: rem(4);

        }

        input {
            grid-area: inputCheckbox;
            cursor: pointer;
        }
    }

    &__goods-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__goods-content {
        margin-top: 25px;
        margin-bottom: 16px;
    }

    &__goods-bottom {
        display: flex;
    }

    &__remove-btn {
        cursor: pointer;
    }

    &__goods-image {
        img {
            display: block;
            max-width: rem(190);
            max-height: rem(190);
            margin: 0 auto;
        }
    }

    &__goods-sale {
        margin-bottom: 4px;
        font-weight: 500;
        font-size: 12px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #C80024;
    }

    &__goods-title {
        text-align: center;
        margin-top: rem(30);
        font-weight: 500;
        font-size: 14px;
        text-align: center;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #191918;
    }

    &__goods-price {
        text-align: center;
        margin-top: rem(18);
        font-size: 16px;
        text-align: center;
        color: #363636;

        span {
            font-size: 14px;
            color: #757575;
            text-decoration: line-through;
            padding-left: 5px;
        }
    }

    &__size-select {
        width: 77%;
        min-width: rem(156);
        height: rem(56);
        margin-right: rem(8);

        @include point-md {
            min-width: rem(106);
        }

        select {
            width: 100%;
            height: rem(56);
            padding: 0 16px;
            background: url("/local/templates/love-you/images/front-end/vector.svg") no-repeat rem(172) center;
        }
    }

    &__cart-btn {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        height: rem(56);
        background-color: #618EAF;
        justify-self: right;
        color: #fff;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        font-weight: 500;
        font-size: rem(16);

        //width: rem(56);
        width: 100%;
        text-align: center;


        span{
            margin-left: 10px;
        }

        @include point-xl {
            font-size: rem(18);

        }

        &--width {
            width: 100%;
        }
    }
}
</style>